import { Observable, of } from 'rxjs';
import 'rxjs/add/observable/throw';
import { Respuesta } from '../models/respuesta';
import swal from 'sweetalert2';

export abstract class BaseService<T> {

  private serviceName: string;

  constructor(name: string) {
    this.serviceName = name;
  }

  abstract findAll(): Observable<T[]>;

  abstract add(data: T): Observable<Respuesta>;

  abstract update(data: T): Observable<Respuesta>;

  abstract delete(id: number): Observable<Respuesta>;

  /**
   * Manejar la operación Http que falló
   * Deja que la aplicación continúe.
   * Retorna el mensaje de error
   * @param operation - Nombre de la operación que falló
   */
  public handleError(operation = 'operation') {
    return (error: any) => {

      // TODO: enviar el error a la infraestructura de registro remoto
      // console.error(error); // log to console instead

      // TODO: mejor trabajo de transformación de error para el consumo del usuario.
      this.log(`${operation} failed: ${error.message}`);

      // Deja que la aplicación siga funcionando devolviendo un resultado vacío.
      return Observable.throw(error.message || error);
    };
  }

  public handleError1(datamessage) {
    return (error: any) => {

      // Muestra un modal de mensaje swal
      // console.log(datamessage);
      // console.log(error.message);
      // console.log(error.error.datamessage);
      // console.log(error);
      const dataError = error.error.datamessage;
      // console.log(dataError);
      swal(dataError.title, dataError.message, dataError.type);

      // Deja que la aplicación siga funcionando devolviendo un resultado vacío.
      return Observable.throw(error.message || error);
    };
  }
  public handleMensaje(datamessage: any) {
    swal(datamessage.title, datamessage.message, datamessage.type);
  }

  public log(message: string) {
    // console.log(`${this.serviceName}: ${message}`);
    // this.messageService.add(`HeroService: ${message}`);
  }
}


/**
 * Manejar la operación Http que falló
 * Deja que la aplicación continúe.
 * @param operation - Nombre de la operación que falló
 * @param result - Valor opcional para devolver como resultado observable.
 */
/*
  public handleErrorNothing<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: enviar el error a la infraestructura de registro remoto
      console.error(error); // log to console instead

      // TODO: mejor trabajo de transformación de error para el consumo del usuario.
      this.log(`${operation} failed: ${error.message}`);

      // Deja que la aplicación siga funcionando devolviendo un resultado vacío.
      return of(result as T);
    };
*/
